<script>
/**
 * Faixa no topo do composer: "● N sugestões a triar →".
 *
 * O rótulo é o mesmo que a tela de destino usa ("A triar" / "sugestões
 * aguardando decisão") — e o número sai da MESMA função dela, então os dois
 * concordam. Faixa que diz 3 e leva a uma tela mostrando 7 é defeito aos olhos
 * de quem clicou.
 *
 * Componente BURRO — recebe a contagem por prop, não lê store nem `$access`.
 * É o que o mantém montável sem sessão no teste, mesma disciplina de
 * `ia-insight-card` e `card-do-dia`. Quem sabe de onde vem o número é quem o
 * preenche pelo slot `cabecalho` do `send-message`.
 *
 * ★ `null` e `0` NÃO são a mesma coisa, e nenhum dos dois renderiza:
 *   `0`    = apurado, fila vazia — não há o que anunciar;
 *   `null` = NÃO apurado (a fonte não respondeu) — anunciar "0 sugestões"
 *            aqui seria afirmar algo falso. Mesma separação que o
 *            `card-do-dia` faz entre "lista vazia" e "origem não conectada".
 */
import { TONS, tokenDoTom } from '@modules/aawz-intelligence-v2/components/ia-insight-card/tons'

const TAMANHO_SETA = 12

export default {
  name: 'IntelligenceV2ComposerAtencao',
  props: {
    // `null` = não apurado. Ver o cabeçalho.
    quantidade: {
      type: Number,
      default: null,
    },
  },
  data() {
    return { TAMANHO_SETA }
  },
  computed: {
    visivel() {
      return isFinite(this.quantidade) && this.quantidade > 0
    },
    // Tom, nunca hex: a paleta muda num lugar só, e a plataforma é white-label.
    corDaBolinha() {
      return tokenDoTom(TONS.ALERTA)
    },
    rotulo() {
      const unidade = this.quantidade === 1 ? 'sugestão' : 'sugestões'
      return `${this.quantidade} ${unidade} a triar`
    },
  },
  methods: {
    aoClicar() {
      this.$emit('abrir')
    },
  },
}
</script>

<template>
  <button
    v-if="visivel"
    type="button"
    class="composer-atencao ia-texto-corpo"
    :title="rotulo"
    @click="aoClicar"
  >
    <span class="composer-atencao__bolinha" :style="{ background: corDaBolinha }" />
    <span class="composer-atencao__rotulo">{{ rotulo }}</span>
    <!-- ⚠️ `arrow-right` NÃO existe na lib (nome inexistente renderiza vazio,
         sem erro). O `arrow-left` é que aponta para a DIREITA — mal nomeado,
         armadilha já registrada em `cliente-sidebar.vue` e no card de insight. -->
    <icon-svg
      name="arrow-left"
      :size="TAMANHO_SETA"
      color="var(--neutral-700)"
      class="composer-atencao__seta"
    />
  </button>
</template>

<style lang="sass" scoped>
// Conteúdo da ABA `.send-message-cabecalho` do composer (14/09/2026 — antes era
// o cabeçalho DENTRO da caixa, sangrando com margens negativas sobre o `pa-3`):
// fundo, raio e recuo são da aba; aqui só o padding, a tipografia e o hover. O
// hover herda o raio da aba para não desenhar um retângulo dentro dela.
.composer-atencao
  color: var(--neutral-900)
  display: flex
  align-items: center
  gap: 8px
  width: 100%
  margin: 0
  padding: 8px 16px
  border: 0
  border-radius: inherit
  background: transparent
  cursor: pointer
  text-align: left
  transition: background var(--motion-duration-fast) var(--motion-easing-standard)

  &:hover
    background: var(--sidebar-warm-hover)

  &:focus-visible
    outline: 2px solid var(--primary)
    outline-offset: -2px

.composer-atencao__bolinha
  flex-shrink: 0
  width: 7px
  height: 7px
  border-radius: 50%

.composer-atencao__rotulo
  flex: 1
  min-width: 0
  overflow: hidden
  white-space: nowrap
  text-overflow: ellipsis

// Aponta para a direita: o SVG da lib já nasce nessa direção (ver o comentário
// no template).
.composer-atencao__seta
  flex-shrink: 0
</style>
